import { Reducer } from '@reduxjs/toolkit';

const lastRecordReducer: Reducer = (
  state, { payload },
) => (
  {
    ...state,
    lastRecord: payload,
  }
);

export default lastRecordReducer;
